/*
 * Click-to-play video (snippets/cf-video-card.liquid).
 * The <video> carries its sources as data attributes and gets real <source>
 * elements only when the card is clicked, so a visitor who never clicks
 * downloads nothing but the poster.
 */
(function () {
  'use strict';
  if (window.__cfVideoInit) return;
  window.__cfVideoInit = true;

  function attach(video) {
    if (video.dataset.loaded) return;
    video.dataset.loaded = '1';
    var hls = video.dataset.hls, mp4 = video.dataset.mp4;
    if (hls) video.appendChild(source(hls, 'application/x-mpegURL'));
    if (mp4) video.appendChild(source(mp4, 'video/mp4'));
    video.load();
  }

  function source(src, type) {
    var s = document.createElement('source');
    s.src = src;
    s.type = type;
    return s;
  }

  function play(video) {
    var p = video.play();
    // A click is a user gesture, so sound is allowed; if a browser refuses
    // anyway, fall back to muted rather than showing a dead player.
    if (p && p.catch) {
      p.catch(function () {
        video.muted = true;
        video.play().catch(function () {});
      });
    }
  }

  function track(name) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('cf_video_play', { video: name });
      }
    } catch (e) {}
  }

  function init(root) {
    if (root.dataset.cfVideoReady) return;
    root.dataset.cfVideoReady = '1';

    var card = root.querySelector('.cf-vid__card');
    var dialog = root.querySelector('.cf-vid__dialog');
    var video = root.querySelector('.cf-vid__video');
    var end = root.querySelector('.cf-vid__end');
    var tracked = false;
    if (!card || !dialog || !video) return;

    // The dialog lives at the end of <body> so no section's overflow or
    // transform can clip or re-anchor it.
    document.body.appendChild(dialog);

    card.addEventListener('click', function () {
      attach(video);
      if (end) end.hidden = true;
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute('open', '');
      video.currentTime = 0;
      play(video);
      if (!tracked) { tracked = true; track(video.dataset.name || ''); }
    });

    function close() {
      if (dialog.close) dialog.close();
      else dialog.removeAttribute('open');
    }

    dialog.addEventListener('close', function () {
      video.pause();
      card.focus({ preventScroll: true });
    });

    // A click on the backdrop lands on the dialog element itself.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    var closeBtn = dialog.querySelector('[data-cf-video-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    if (end) {
      video.addEventListener('ended', function () { end.hidden = false; });
      video.addEventListener('play', function () { end.hidden = true; });

      var replay = end.querySelector('[data-cf-video-replay]');
      if (replay) replay.addEventListener('click', function () {
        video.currentTime = 0;
        play(video);
      });

      var cta = end.querySelector('[data-cf-video-cta]');
      if (cta) cta.addEventListener('click', function (e) {
        var href = cta.getAttribute('href') || '';
        if (href.charAt(0) !== '#') { close(); return; }
        var target = document.querySelector(href);
        if (!target) { close(); return; }
        e.preventDefault();
        close();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Put the customer straight into the first empty picker field.
        var field = target.querySelector('select:not([disabled]), input:not([type=hidden])');
        if (field) field.focus({ preventScroll: true });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cf-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: sections re-render in place.
  document.addEventListener('shopify:section:load', initAll);
})();
